import type { FaireProductEntity } from "../../entity_types/product";

export const p_f47uv9m5np: FaireProductEntity = {
  token: "p_f47uv9m5np",
  type: "product",
  name: "Cherry Relief - The Flow State Collection - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/d137882b51eee642f230edd9518dca19e5a880e15843453e399b8d40f949d64e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/95fd48edaea4a6fdc76a9ca1fd234994669c43e56d0a39c1a90620cfbd32532b.jpeg"
  ],
  priceDollars: 58,
  description: "SUPERFOOD TEA BLEND \n\nSip your way back to balance with this bright and juicy blend designed to soothe the luteal phase lows and promote hormone harmony. Raspberry leaf lends its uterine-toning power, and tulsi and lemon balm work to banish period-related anxiety and brain fog. It’s the ultimate self-care ritual for staying grounded all month long.\n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED \n\nTHE FLOW STATE COLLECTION - our first family of functional teas designed to help you feel your best during your cycle, so you can slow down and sync with your body’s natural rhythm.\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \nWhen to Steep:\n\n\n * During your luteal phase. \n * When you need to reduce bloating and ease cramping. \n * As a soothing, all-day caffeine-free tea. \n * To calm your nerves and promote calmness and clarity. \nCaffeine-free\n",
  tags: [],
  msrpDollars: 116,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:40.797Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
